const updateStatus = (state, { status, error = null }) => {
  state.meta = {
    status,
    error
  }
}

export default updateStatus
